<ng-container [ngSwitch]="getComponentSwitchString(item.name)">

  <app-rsvp-event *ngSwitchCase="'app-rsvp-event'"
                  [item]="item"
                  class="flex w-100">
  </app-rsvp-event>

  <app-connection-event *ngSwitchCase="'app-connection-event'"
                        [item]="item"
                        class="flex w-100">
  </app-connection-event>

  <app-contact-logged-event *ngSwitchCase="activityEventNames.CreateContactAttemptCustomFormContacted"
                            [item]="item"
                            class="flex w-100"></app-contact-logged-event>

  <app-response-event *ngSwitchCase="'app-response-event'"
                      [item]="item"
                      class="flex w-100">
  </app-response-event>

  <app-assessment-event *ngSwitchCase="activityEventNames.CreateAssessment"
                        [item]="item"
                        class="flex w-100">
  </app-assessment-event>

  <app-remove-entity-event *ngSwitchCase="activityEventNames.RemoveEntityFromCampaign"
                           [item]="item"
                           class="flex w-100">
  </app-remove-entity-event>

  <app-mass-add-entities-to-campaign-event *ngSwitchCase="activityEventNames.MassAddEntitiesToCampaign"
                                           [item]="item"
                                           class="flex w-100">
  </app-mass-add-entities-to-campaign-event>

  <app-mass-add-assessment-event *ngSwitchCase="activityEventNames.MassAddAssessment"
                                 [item]="item"
                                 class="flex w-100">
  </app-mass-add-assessment-event>

  <app-mass-apply-tags-event *ngSwitchCase="activityEventNames.MassApplyTags"
                             [item]="item"
                             class="flex w-100">
  </app-mass-apply-tags-event>

  <app-mass-complete-follow-up-event *ngSwitchCase="activityEventNames.MassCompleteFollowUp"
                                     [item]="item"
                                     class="flex w-100">
  </app-mass-complete-follow-up-event>

  <app-mass-add-follow-up-event *ngSwitchCase="activityEventNames.MassAddFollowUp"
                                [item]="item"
                                class="flex w-100">
  </app-mass-add-follow-up-event>

  <app-mass-remove-tags-event *ngSwitchCase="activityEventNames.MassRemoveTags"
                              [item]="item"
                              class="flex w-100">
  </app-mass-remove-tags-event>

  <app-mass-assign-to-action-event *ngSwitchCase="activityEventNames.MassAddEntitiesToAction"
                              [item]="item"
                              class="flex w-100">
  </app-mass-assign-to-action-event>

  <app-mass-remove-connection-event *ngSwitchCase="activityEventNames.MassRemoveEntityConnection"
                                    [item]="item"
                                    class="flex w-100">
  </app-mass-remove-connection-event>

  <app-mass-update-connection-event *ngSwitchCase="activityEventNames.MassAddOrUpdateEntityConnection"
                                    [item]="item"
                                    class="flex w-100">
  </app-mass-update-connection-event>

  <app-note-event *ngSwitchCase="activityEventNames.CreateEntityGlobalNote"
                  [item]="item"
                  class="flex w-100">
  </app-note-event>

  <app-follow-up-event *ngSwitchCase="'app-follow-up-event'"
                       [item]="item"
                       class="flex w-100">
  </app-follow-up-event>

  <app-relationship-event *ngSwitchCase="activityEventNames.CreateRelationship"
                          [item]="item"
                          class="flex w-100">
  </app-relationship-event>

  <app-upload-event *ngSwitchCase="activityEventNames.CreateUpload"
                    [item]="item"
                    class="flex w-100">
  </app-upload-event>

  <app-export-event *ngSwitchCase="activityEventNames.Export"
                    [item]="item"
                    class="flex w-100">
  </app-export-event>

  <app-contact-info-event *ngSwitchCase="'app-contact-info-event'"
                          [item]="item"
                          class="flex w-100"></app-contact-info-event>

  <app-new-entity-event *ngSwitchCase="activityEventNames.CreateCampaignEntity"
                        [item]="item"
                        class="flex w-100"></app-new-entity-event>

  <app-create-user-event *ngSwitchCase="activityEventNames.CreateUser"
                         [item]="item"
                         class="flex w-100"></app-create-user-event>


  <app-connection-event *ngSwitchCase="activityEventNames.CreateEntityConnection"
                        [item]="item"
                        class="flex w-100"></app-connection-event>

  <app-canvass-attempt-event *ngSwitchCase="'app-canvass-attempt-event'"
                             [item]="item"
                             class="flex w-100">
  </app-canvass-attempt-event>

</ng-container>
